export default [
  {
    path: 'files',
    name: 'fs.files',
    meta: { type: 1 },
    component: () =>
      import(/* webpackChunkName: "fs.files" */ '@/views/FS/Lists/index.vue'),
  },
]
